import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["provisioningStatus"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { formatPercentage, sortModulesAlphabetically, usageTypes } from '~/assets/helper/functions';
import { latestReferencePeriodYear } from '~/functions/referencePeriods';
import { Module, useAddPortfolioVentureLinkMutation, useDeletePortfolioVentureLinkMutation, useGetAccountQuery, useListAccountsQuery, useUpdateAccountMutation, AccountCategory, MetricReportingPeriodType } from '~/types/types';
import { useRoute, useRouter } from '#app';
export default /*#__PURE__*/_defineComponent({
  __name: 'Accounts',
  props: {
    type: {
      type: String,
      default: 'table'
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    modelValue: {
      type: Array,
      default: undefined
    },
    additionalHeaders: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    columns: {
      type: Array,
      default: function _default() {
        return ['name'];
      }
    },
    portfolioId: {
      type: String,
      default: '',
      required: false
    },
    showAdd: {
      type: Boolean,
      default: false,
      required: false
    },
    showGroups: {
      type: Boolean,
      default: false,
      required: false
    },
    showPeriodSelect: {
      type: Boolean,
      default: false,
      required: false
    },
    syncFiltersInUrl: {
      type: Boolean,
      default: false,
      required: false
    },
    question: {
      type: Object,
      default: function _default() {
        return {};
      },
      required: false
    },
    filters: {
      type: Object,
      default: function _default() {
        return {};
      },
      required: false
    },
    externalLoading: {
      type: Boolean,
      default: false,
      required: false
    },
    accountType: {
      type: String,
      required: false,
      default: function _default() {
        return AccountCategory.Portfolio;
      }
    },
    /** Full id list for header select-all / deselect-all across pages. */
    allSelectableIds: {
      type: Array,
      default: undefined,
      required: false
    }
  },
  emits: ['input', 'update:modelValue'],
  setup: function setup(__props, _ref) {
    var _getSingleQueryValue, _getSingleQueryValue2, _getSingleQueryValue3, _account$value, _account$value$defaul, _account$value2, _account$value2$defau;
    var emit = _ref.emit;
    var props = __props;
    var route = useRoute();
    var router = useRouter();
    var getSingleQueryValue = function getSingleQueryValue(value) {
      return Array.isArray(value) ? value[0] : value !== null && value !== void 0 ? value : undefined;
    };
    var currentIds = computed(function () {
      return (props.modelValue !== undefined ? props.modelValue : props.value) || [];
    });
    var onInput = function onInput(v) {
      emit('update:modelValue', v);
      emit('input', v);
    };
    var onTableInput = function onTableInput(v) {
      selected.value = items.value.filter(function (item) {
        return v.includes(item.id);
      }).map(function (it) {
        return _objectSpread(_objectSpread({}, it), {}, {
          groupIds: getFirstPortfolioLinkGroupIds(it),
          ventureId: it.id
        });
      });
      emit('update:modelValue', v);
      emit('input', v);
    };
    var _useGetAccountQuery = useGetAccountQuery(),
      accountResult = _useGetAccountQuery.result;
    var account = computed(function () {
      var _accountResult$value;
      return (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount;
    });
    var allHeaders = computed(function () {
      return _objectSpread({
        id: {
          width: '20px',
          text: 'ID',
          value: 'id',
          cellClass: ' font-weight-bold subtitle-2',
          sort: 1
        },
        name: {
          value: 'name',
          cellClass: ' font-weight-bold subtitle-2',
          sort: 2
        },
        logo: {
          text: '',
          width: '48px',
          value: 'logo',
          cellClass: ' font-weight-bold subtitle-2',
          sort: 1.5,
          sortable: false
        },
        type: {
          width: '100px',
          value: 'type',
          cellClass: 'text-center font-weight-bold subtitle-2',
          sort: 3,
          sortable: false
        },
        usageType: {
          width: '250px',
          value: 'usageType',
          cellClass: 'text-center font-weight-bold subtitle-2',
          sortable: true,
          sort: 4
        },
        modules: {
          width: '290px',
          value: 'modules',
          cellClass: '',
          sort: 5,
          sortable: false
        },
        bookedModules: {
          value: 'bookedModules',
          cellClass: '',
          sort: 5.5,
          sortable: false
        },
        users: {
          value: 'users',
          cellClass: '',
          sort: 6,
          sortable: false
        },
        'portfolioLinks.groupNames': {
          width: '290px',
          value: 'portfolioLinks.groupNames',
          cellClass: '',
          sort: 6.5,
          sortable: false
        },
        usersCount: {
          value: 'usersCount',
          cellClass: '',
          sort: 6.6,
          sortable: false
        },
        provisioningStatus: {
          value: 'provisioningStatus',
          cellClass: 'text-center',
          width: '168px',
          sort: 6.65,
          sortable: false
        },
        metricAssignmentsCount: {
          value: 'metricAssignmentsCount',
          cellClass: '',
          sort: 6.5,
          sortable: false
        },
        'completionRates.completionRate': {
          value: 'completionRates.completionRate',
          cellClass: '',
          sort: 7,
          sortable: false
        },
        'completionRates.skippedRate': {
          value: 'completionRates.skippedRate',
          cellClass: '',
          sort: 7.5,
          sortable: false
        },
        'completionRates.responseRate': {
          value: 'completionRates.responseRate',
          cellClass: '',
          sort: 8,
          sortable: false
        },
        createdAt: {
          text: 'Created',
          value: 'createdAt',
          cellClass: '',
          sort: 9
        },
        actions: {
          text: 'Action',
          value: 'actions',
          cellClass: 'text-center',
          width: '50px',
          sort: 10,
          sortable: false
        }
      }, props.additionalHeaders);
    });
    var headers = computed(function () {
      var _props$columns;
      return (_props$columns = props.columns) === null || _props$columns === void 0 ? void 0 : _props$columns.map(function (header) {
        var ah = allHeaders.value;
        if (_typeof(header) === 'object' && header !== null && header !== void 0 && header.value) {
          return _objectSpread(_objectSpread({}, ah[header.value || header]), header);
        } else {
          if (!ah[header]) {
            console.warn(header, 'does NOT exist!!!!!', header);
            return {};
          }
          return ah[header];
        }
      });
    });
    var options = ref(_objectSpread({
      page: 1,
      itemsPerPage: props.type === 'table' ? 10 : -1,
      sortBy: ['name'],
      sortDesc: [false]
    }, props.options || {}));
    var PROVISIONING_STATUS_VALUES = ['active', 'pending', 'invite_sent'];
    var parseProvisioningStatusQuery = function parseProvisioningStatusQuery(value) {
      if (value == null || value === '') {
        return [];
      }
      var raw = Array.isArray(value) ? value.join(',') : String(value);
      return raw.split(',').map(function (part) {
        return part.trim();
      }).filter(function (part) {
        return PROVISIONING_STATUS_VALUES.includes(part);
      });
    };
    var internalFilters = ref(_objectSpread(_objectSpread({
      keyword: props.syncFiltersInUrl ? (_getSingleQueryValue = getSingleQueryValue(route.query.search)) !== null && _getSingleQueryValue !== void 0 ? _getSingleQueryValue : '' : '',
      group: props.syncFiltersInUrl ? (_getSingleQueryValue2 = getSingleQueryValue(route.query.group)) !== null && _getSingleQueryValue2 !== void 0 ? _getSingleQueryValue2 : 'All companies' : 'All companies',
      provisioningStatus: props.syncFiltersInUrl ? parseProvisioningStatusQuery(getSingleQueryValue(route.query.status)) : []
    }, props.filters), {}, {
      period: props.syncFiltersInUrl ? (_getSingleQueryValue3 = getSingleQueryValue(route.query.period)) !== null && _getSingleQueryValue3 !== void 0 ? _getSingleQueryValue3 : ((_account$value = account.value) === null || _account$value === void 0 ? void 0 : (_account$value$defaul = _account$value.defaultReferencePeriods) === null || _account$value$defaul === void 0 ? void 0 : _account$value$defaul.length) > 0 ? String(latestReferencePeriodYear(account.value.defaultReferencePeriods)) : '2024' : ((_account$value2 = account.value) === null || _account$value2 === void 0 ? void 0 : (_account$value2$defau = _account$value2.defaultReferencePeriods) === null || _account$value2$defau === void 0 ? void 0 : _account$value2$defau.length) > 0 ? String(latestReferencePeriodYear(account.value.defaultReferencePeriods)) : '2024'
    }));
    watch(account, function (newAccount) {
      var _newAccount$defaultRe, _newAccount$defaultRe2;
      if (!props.syncFiltersInUrl && (newAccount === null || newAccount === void 0 ? void 0 : (_newAccount$defaultRe = newAccount.defaultReferencePeriods) === null || _newAccount$defaultRe === void 0 ? void 0 : _newAccount$defaultRe.length) > 0) {
        internalFilters.value.period = String(latestReferencePeriodYear(newAccount.defaultReferencePeriods));
        return;
      }
      if (getSingleQueryValue(route.query.period) != null) return;
      if ((newAccount === null || newAccount === void 0 ? void 0 : (_newAccount$defaultRe2 = newAccount.defaultReferencePeriods) === null || _newAccount$defaultRe2 === void 0 ? void 0 : _newAccount$defaultRe2.length) > 0) {
        internalFilters.value.period = String(latestReferencePeriodYear(newAccount.defaultReferencePeriods));
      }
    });
    watch(function () {
      return route.query;
    }, function (query) {
      if (!props.syncFiltersInUrl) return;
      var periodQuery = getSingleQueryValue(query.period);
      var groupQuery = getSingleQueryValue(query.group);
      var searchQuery = getSingleQueryValue(query.search);
      var statusQuery = getSingleQueryValue(query.status);
      if (periodQuery != null && periodQuery !== internalFilters.value.period) {
        internalFilters.value.period = periodQuery;
      }
      if (groupQuery != null && groupQuery !== internalFilters.value.group) {
        internalFilters.value.group = groupQuery;
      }
      if (searchQuery != null && searchQuery !== internalFilters.value.keyword) {
        internalFilters.value.keyword = searchQuery;
      }
      if (statusQuery != null) {
        internalFilters.value.provisioningStatus = parseProvisioningStatusQuery(statusQuery);
      } else {
        internalFilters.value.provisioningStatus = [];
      }
    });
    watch(function () {
      return {
        period: internalFilters.value.period,
        group: internalFilters.value.group,
        keyword: internalFilters.value.keyword,
        provisioningStatus: _toConsumableArray(internalFilters.value.provisioningStatus)
      };
    }, function (value) {
      var _getSingleQueryValue4, _getSingleQueryValue5, _getSingleQueryValue6, _value$period, _value$group, _value$keyword, _value$provisioningSt;
      if (!props.syncFiltersInUrl) return;
      var currentPeriod = (_getSingleQueryValue4 = getSingleQueryValue(route.query.period)) !== null && _getSingleQueryValue4 !== void 0 ? _getSingleQueryValue4 : '';
      var currentGroup = (_getSingleQueryValue5 = getSingleQueryValue(route.query.group)) !== null && _getSingleQueryValue5 !== void 0 ? _getSingleQueryValue5 : '';
      var currentSearch = (_getSingleQueryValue6 = getSingleQueryValue(route.query.search)) !== null && _getSingleQueryValue6 !== void 0 ? _getSingleQueryValue6 : '';
      var currentStatus = parseProvisioningStatusQuery(getSingleQueryValue(route.query.status)).join(',');
      var nextPeriod = (_value$period = value.period) !== null && _value$period !== void 0 ? _value$period : '';
      var nextGroup = (_value$group = value.group) !== null && _value$group !== void 0 ? _value$group : '';
      var nextSearch = (_value$keyword = value.keyword) !== null && _value$keyword !== void 0 ? _value$keyword : '';
      var nextStatus = ((_value$provisioningSt = value.provisioningStatus) !== null && _value$provisioningSt !== void 0 ? _value$provisioningSt : []).join(',');
      if (currentPeriod === nextPeriod && currentGroup === nextGroup && currentSearch === nextSearch && currentStatus === nextStatus) {
        return;
      }
      router.replace({
        query: _objectSpread(_objectSpread({}, route.query), {}, {
          period: nextPeriod || undefined,
          group: nextGroup || undefined,
          search: nextSearch || undefined,
          status: nextStatus || undefined,
          setupOnly: undefined
        })
      });
    }, {
      deep: true
    });
    function portfolioLinkForVenture(item) {
      var _links$;
      var links = item === null || item === void 0 ? void 0 : item.portfolioLinks;
      if (!Array.isArray(links) || links.length === 0) {
        return null;
      }
      if (props.portfolioId) {
        var matched = links.find(function (link) {
          return String(link.portfolioId) === String(props.portfolioId);
        });
        if (matched) {
          return matched;
        }
      }
      return (_links$ = links[0]) !== null && _links$ !== void 0 ? _links$ : null;
    }
    var itemCompanyUserInvites = function itemCompanyUserInvites(item) {
      var _portfolioLinkForVent, _portfolioLinkForVent2;
      return (_portfolioLinkForVent = (_portfolioLinkForVent2 = portfolioLinkForVenture(item)) === null || _portfolioLinkForVent2 === void 0 ? void 0 : _portfolioLinkForVent2.companyUserInvites) !== null && _portfolioLinkForVent !== void 0 ? _portfolioLinkForVent : [];
    };
    function ventureProvisioningStatus(usersCount, invites) {
      if ((usersCount !== null && usersCount !== void 0 ? usersCount : 0) > 0) {
        return 'active';
      }
      if (Array.isArray(invites) && invites.length > 0) {
        return 'invite_sent';
      }
      return 'pending';
    }
    var itemProvisioningStatus = function itemProvisioningStatus(item) {
      return ventureProvisioningStatus(itemUsersCount(item), itemCompanyUserInvites(item));
    };
    function provisioningStatusChipAttrs(status) {
      var color = status === 'active' ? 'success' : status === 'invite_sent' ? 'primary' : status === 'pending' ? 'warning' : 'grey';
      return {
        color: color,
        outlined: true
      };
    }
    var showProvisioningStatusFilter = computed(function () {
      return props.columns.includes('provisioningStatus');
    });
    var provisioningStatusFilterOptions = [{
      value: 'active'
    }, {
      value: 'pending'
    }, {
      value: 'invite_sent'
    }];
    var provisioningStatusFilterLength = computed(function () {
      var _internalFilters$valu, _internalFilters$valu2;
      return (_internalFilters$valu = (_internalFilters$valu2 = internalFilters.value.provisioningStatus) === null || _internalFilters$valu2 === void 0 ? void 0 : _internalFilters$valu2.length) !== null && _internalFilters$valu !== void 0 ? _internalFilters$valu : 0;
    });
    var hasProvisioningStatusFilter = computed(function () {
      return provisioningStatusFilterLength.value > 0;
    });
    function onProvisioningStatusFilterChange() {
      options.value.page = 1;
    }
    var listAccountFilters = computed(function () {
      var _internalFilters$valu3 = internalFilters.value,
        provisioningStatus = _internalFilters$valu3.provisioningStatus,
        graphqlFilters = _objectWithoutProperties(_internalFilters$valu3, _excluded);
      return graphqlFilters;
    });
    var listAccountsQueryEnabled = computed(function () {
      if (!props.syncFiltersInUrl) {
        return true;
      }
      var urlPeriod = getSingleQueryValue(route.query.period);
      if (urlPeriod != null && urlPeriod !== '') {
        return true;
      }
      return Boolean(account.value);
    });
    var variables = computed(function () {
      var pageSize = options.value.itemsPerPage;
      var useClientStatusFilter = hasProvisioningStatusFilter.value;
      return {
        filters: listAccountFilters.value,
        offset: useClientStatusFilter ? 0 : pageSize * (options.value.page - 1),
        limit: useClientStatusFilter ? -1 : pageSize,
        sort: options.value.sortBy.map(function (item, index) {
          return {
            field: item,
            sortDesc: options.value.sortDesc[index]
          };
        })
      };
    });
    var _useListAccountsQuery = useListAccountsQuery(variables, computed(function () {
        return {
          fetchPolicy: 'network-only',
          enabled: listAccountsQueryEnabled.value
        };
      })),
      result = _useListAccountsQuery.result,
      refetch = _useListAccountsQuery.refetch,
      loading = _useListAccountsQuery.loading;
    var isTableLoading = computed(function () {
      return props.externalLoading && Object.values(loading.value).some(Boolean);
    });
    var listAccountsRaw = computed(function () {
      var _result$value;
      return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listAccounts) || [];
    });
    var listAccountsFilteredByStatus = computed(function () {
      var selected = internalFilters.value.provisioningStatus;
      if (!(selected !== null && selected !== void 0 && selected.length)) {
        return listAccountsRaw.value;
      }
      return listAccountsRaw.value.filter(function (item) {
        return selected.includes(itemProvisioningStatus(item));
      });
    });
    var itemCount = computed(function () {
      var _result$value$countAc, _result$value2;
      return hasProvisioningStatusFilter.value ? listAccountsFilteredByStatus.value.length : (_result$value$countAc = (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countAccounts) !== null && _result$value$countAc !== void 0 ? _result$value$countAc : 0;
    });
    var items = computed(function () {
      if (!hasProvisioningStatusFilter.value) {
        return listAccountsRaw.value;
      }
      var pageSize = options.value.itemsPerPage;
      if (pageSize === -1) {
        return listAccountsFilteredByStatus.value;
      }
      var start = pageSize * (options.value.page - 1);
      return listAccountsFilteredByStatus.value.slice(start, start + pageSize);
    });
    var toDeleteVentureId = ref(null);
    var _useDeletePortfolioVe = useDeletePortfolioVentureLinkMutation(),
      deletePortfolioVentureLink = _useDeletePortfolioVe.mutate;
    var toAddVentureIds = ref(null);
    var _useAddPortfolioVentu = useAddPortfolioVentureLinkMutation(),
      addPortfolioVentureLink = _useAddPortfolioVentu.mutate;
    var selected = ref([]);
    var moduleByKey = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Module.Esg, 'ESG'), Module.Metrics, 'KPI'), Module.Sfdr, 'SFDR(FUND)'), Module.Csrd, 'CSRD'), Module.ImpactGoal, 'Impact'), Module.Annotation, 'Annotation'), Module.Impact, 'Deprecated Impact'), Module.ImpactStrategy, "Impact Strategy");
    var sortedModules = function sortedModules(mods) {
      return sortModulesAlphabetically(mods, moduleByKey);
    };
    var _useUpdateAccountMuta = useUpdateAccountMutation(),
      updateAccount = _useUpdateAccountMuta.mutate;
    var getHeaderValue = function getHeaderValue(header) {
      var _ref2;
      return (_ref2 = header && header.value) !== null && _ref2 !== void 0 ? _ref2 : '';
    };
    var getFirstPortfolioLinkGroupIds = function getFirstPortfolioLinkGroupIds(account) {
      var links = account && account.portfolioLinks;
      var first = Array.isArray(links) && links[0] ? links[0] : null;
      return first && first.groupIds ? first.groupIds : undefined;
    };
    var itemUsersCount = function itemUsersCount(item) {
      return item != null && 'usersCount' in item ? item.usersCount : undefined;
    };
    var itemMetricAssignmentsCount = function itemMetricAssignmentsCount(item) {
      return item != null && 'metricAssignmentsCount' in item ? item.metricAssignmentsCount : undefined;
    };
    var itemCompletionRate = function itemCompletionRate(item) {
      return item && item.completionRates ? item.completionRates.completionRate : undefined;
    };
    var itemSkippedRate = function itemSkippedRate(item) {
      return item && item.completionRates ? item.completionRates.skippedRate : undefined;
    };
    var itemResponseRate = function itemResponseRate(item) {
      return item && item.completionRates ? item.completionRates.responseRate : undefined;
    };
    var itemTotalMetrics = function itemTotalMetrics(item) {
      return item && item.completionRates ? item.completionRates.totalMetrics : undefined;
    };
    var itemCompletedMetrics = function itemCompletedMetrics(item) {
      return item && item.completionRates ? item.completionRates.completedMetrics : undefined;
    };
    var itemSkippedMetrics = function itemSkippedMetrics(item) {
      return item && item.completionRates ? item.completionRates.skippedMetrics : undefined;
    };
    var itemQuarterlyMetrics = function itemQuarterlyMetrics(item) {
      return item && item.completionRates ? item.completionRates.quarterlyMetrics : undefined;
    };
    var itemAnnualMetrics = function itemAnnualMetrics(item) {
      return item && item.completionRates ? item.completionRates.annualMetrics : undefined;
    };
    var formatRateFraction = function formatRateFraction(numerator, denominator) {
      var safeNumerator = typeof numerator === 'number' ? numerator : 0;
      var safeDenominator = typeof denominator === 'number' ? denominator : 0;
      return "".concat(safeNumerator, "/").concat(safeDenominator);
    };
    var completionRateTooltipText = function completionRateTooltipText(item) {
      return formatRateFraction(itemCompletedMetrics(item), itemTotalMetrics(item));
    };
    var skippedRateTooltipText = function skippedRateTooltipText(item) {
      return formatRateFraction(itemSkippedMetrics(item), itemTotalMetrics(item));
    };
    var responseRateTooltipText = function responseRateTooltipText(item) {
      var _itemCompletedMetrics, _itemSkippedMetrics;
      return formatRateFraction(((_itemCompletedMetrics = itemCompletedMetrics(item)) !== null && _itemCompletedMetrics !== void 0 ? _itemCompletedMetrics : 0) + ((_itemSkippedMetrics = itemSkippedMetrics(item)) !== null && _itemSkippedMetrics !== void 0 ? _itemSkippedMetrics : 0), itemTotalMetrics(item));
    };
    var metricAssignmentsCountTooltipText = function metricAssignmentsCountTooltipText(item) {
      var _itemQuarterlyMetrics, _itemAnnualMetrics, _itemMetricAssignment;
      return "Quarterly: ".concat((_itemQuarterlyMetrics = itemQuarterlyMetrics(item)) !== null && _itemQuarterlyMetrics !== void 0 ? _itemQuarterlyMetrics : 0, ", Annual: ").concat((_itemAnnualMetrics = itemAnnualMetrics(item)) !== null && _itemAnnualMetrics !== void 0 ? _itemAnnualMetrics : 0, ", Total: ").concat((_itemMetricAssignment = itemMetricAssignmentsCount(item)) !== null && _itemMetricAssignment !== void 0 ? _itemMetricAssignment : 0);
    };
    var itemPortfolioGroupNames = function itemPortfolioGroupNames(item) {
      var links = item && item.portfolioLinks;
      if (!Array.isArray(links)) return '';
      var link = links.find(function (l) {
        return l.portfolioId === props.portfolioId;
      });
      var names = link && link.groupNames;
      return Array.isArray(names) ? names.join(', ') : '';
    };
    var hasExistingUsers = function hasExistingUsers(item) {
      return (item != null && 'usersCount' in item ? item.usersCount : 0) > 0;
    };
    var formatInviteSentAt = function formatInviteSentAt(sentAt) {
      if (!sentAt) return '';
      var date = new Date(sentAt);
      return date.toLocaleString(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    };
    var periodItems = computed(function () {
      var _account$value3;
      var years = Array.from({
        length: 2030 - 2020
      }, function (_, index) {
        return 2020 + index;
      });
      var items = [];
      if (((_account$value3 = account.value) === null || _account$value3 === void 0 ? void 0 : _account$value3.reportingPeriodType) === MetricReportingPeriodType.Quarterly) {
        years.forEach(function (year) {
          items.push("".concat(year, " Q1"), "".concat(year, " Q2"), "".concat(year, " Q3"), "".concat(year, " Q4"));
          items.push(String(year));
        });
      } else {
        items.push.apply(items, _toConsumableArray(years.map(String)));
      }
      return items;
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      route: route,
      router: router,
      getSingleQueryValue: getSingleQueryValue,
      currentIds: currentIds,
      onInput: onInput,
      onTableInput: onTableInput,
      accountResult: accountResult,
      account: account,
      allHeaders: allHeaders,
      headers: headers,
      options: options,
      PROVISIONING_STATUS_VALUES: PROVISIONING_STATUS_VALUES,
      parseProvisioningStatusQuery: parseProvisioningStatusQuery,
      internalFilters: internalFilters,
      portfolioLinkForVenture: portfolioLinkForVenture,
      itemCompanyUserInvites: itemCompanyUserInvites,
      ventureProvisioningStatus: ventureProvisioningStatus,
      itemProvisioningStatus: itemProvisioningStatus,
      provisioningStatusChipAttrs: provisioningStatusChipAttrs,
      showProvisioningStatusFilter: showProvisioningStatusFilter,
      provisioningStatusFilterOptions: provisioningStatusFilterOptions,
      provisioningStatusFilterLength: provisioningStatusFilterLength,
      hasProvisioningStatusFilter: hasProvisioningStatusFilter,
      onProvisioningStatusFilterChange: onProvisioningStatusFilterChange,
      listAccountFilters: listAccountFilters,
      listAccountsQueryEnabled: listAccountsQueryEnabled,
      variables: variables,
      result: result,
      refetch: refetch,
      loading: loading,
      isTableLoading: isTableLoading,
      listAccountsRaw: listAccountsRaw,
      listAccountsFilteredByStatus: listAccountsFilteredByStatus,
      itemCount: itemCount,
      items: items,
      toDeleteVentureId: toDeleteVentureId,
      deletePortfolioVentureLink: deletePortfolioVentureLink,
      toAddVentureIds: toAddVentureIds,
      addPortfolioVentureLink: addPortfolioVentureLink,
      selected: selected,
      moduleByKey: moduleByKey,
      sortedModules: sortedModules,
      updateAccount: updateAccount,
      getHeaderValue: getHeaderValue,
      getFirstPortfolioLinkGroupIds: getFirstPortfolioLinkGroupIds,
      itemUsersCount: itemUsersCount,
      itemMetricAssignmentsCount: itemMetricAssignmentsCount,
      itemCompletionRate: itemCompletionRate,
      itemSkippedRate: itemSkippedRate,
      itemResponseRate: itemResponseRate,
      itemTotalMetrics: itemTotalMetrics,
      itemCompletedMetrics: itemCompletedMetrics,
      itemSkippedMetrics: itemSkippedMetrics,
      itemQuarterlyMetrics: itemQuarterlyMetrics,
      itemAnnualMetrics: itemAnnualMetrics,
      formatRateFraction: formatRateFraction,
      completionRateTooltipText: completionRateTooltipText,
      skippedRateTooltipText: skippedRateTooltipText,
      responseRateTooltipText: responseRateTooltipText,
      metricAssignmentsCountTooltipText: metricAssignmentsCountTooltipText,
      itemPortfolioGroupNames: itemPortfolioGroupNames,
      hasExistingUsers: hasExistingUsers,
      formatInviteSentAt: formatInviteSentAt,
      periodItems: periodItems,
      formatPercentage: formatPercentage,
      usageTypes: usageTypes
    };
  }
});